import { xml2ast, allHtmlParsers, printHtmlNodesToJsx, printHtmlNodesToText, generateJsxKey } from '@utils/ast';
import { PM2ImageHotspotsComponent } from './comp.root.js';
import { jsx } from 'react/jsx-runtime';

const printImageHotspotsComponent = (node, context) => {
  if (!node.pm2.transcript && node.component.data.background?.longDesc) {
    node.pm2.transcript = xml2ast(node.component.data.background.longDesc, allHtmlParsers, "text/html");
  }
  return /*#__PURE__*/jsx(PM2ImageHotspotsComponent, {
    displayMode: node.options.displayMode,
    isScrambled: node.pm2.isScrambled,
    previewImage: node.meta.previewImage,
    indexOrLevel: node.meta.indexOrLevel,
    lightboxDescription: printHtmlNodesToText(node.meta.lightboxDescription ?? []),
    richtextDescription: printHtmlNodesToJsx(node.meta.richTextDescription),
    node: node
  }, generateJsxKey(context));
};
const imageHotspotsComponentJsxPrinters = {
  "component-framework.image-hotspots": printImageHotspotsComponent
};

export { imageHotspotsComponentJsxPrinters, printImageHotspotsComponent };
//# sourceMappingURL=printer.to-jsx.js.map
